import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c578a8ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "refresh-container" }
const _hoisted_3 = { class: "search-item" }
const _hoisted_4 = { class: "item1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_6 = {
  key: 0,
  class: "van-list-container"
}

import { Dialog, Toast } from 'vant';
import Api from '@/http/api/index'
import { useRouter } from "vue-router";
import { Ref, ref, onMounted } from 'vue';
interface GovDepartmentDetailItem {
    appointGovItemId: string,
    appointGovDepartId: string,
    appointGovItemName: string,
    appointInfo: string,
    writeOff: string,
    remark: string,
    createTime: string,
    updateTime: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const TAG = "taxBusinessSelection";
let memberId: string = '';
let govId: string = '';

const loading = ref(false);
const onRefresh = () => {
    loadData(() => {
        setTimeout(() => {
            // Toast('刷新成功');
            loading.value = false;
            // count.value++;
        }, 1000);
    })
};

const searchValue = ref('');

const govDetailList: GovDepartmentDetailItem[] = []
const serviceList: Ref<string[]> = ref([]);
const listLoading = ref(false);
const finished = ref(false);

onMounted(() => {
    loadData();
})

const loadData = (success?: () => void, fail?: () => void) => {
    let currentMemberID = router.currentRoute.value.query.memberId;
    let currentGovId = router.currentRoute.value.query.govId;
    if (currentMemberID) {
        memberId = `${currentMemberID}`;
    }

    if (currentGovId) {
        govId = `${currentGovId}`;
    }

    getAppointGovItemList(govId, data => {
        success && success();
        if (Array.isArray(data)) {
            govDetailList.splice(0, govDetailList.length);
            govDetailList.push(...data);
            serviceList.value.splice(0, serviceList.value.length);
            serviceList.value.push(...data.map((item) => item.appointGovItemName));
            listLoading.value = false;
            finished.value = true;
        }
    }, value => {
        fail && fail();
    })
}

const clickSearchBtn = () => {
    console.log('searchValue:', searchValue.value)
    getAppointGovItemList(govId, data => {
        if (Array.isArray(data)) {
            let filterData = data.filter((item) => item.appointGovItemName && item.appointGovItemName.indexOf(searchValue.value) !== -1)
            govDetailList.splice(0, govDetailList.length);
            govDetailList.push(...filterData);
            serviceList.value.splice(0, serviceList.value.length);
            serviceList.value.push(...filterData.map((item) => item.appointGovItemName));
            listLoading.value = false;
            finished.value = true;
        }
    }, value => { })
}

const getAppointGovItemList = (appointGovDepartId: string, success: (value: GovDepartmentDetailItem[]) => void, fail: (value: any) => void) => {
    Api.getAppointGovItemList({
        params: {
            appointGovDepartId
        },
        success: (res: any) => {
            console.log('success:', res);
            if (res.code == 0) {
                success(res.data as GovDepartmentDetailItem[])
            } else {
                Toast('' + res.msg)
                fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast('' + value)
            fail('' + value)
        }
    })
}

const clickSelectedService = (index: number) => {
    router.push({
        path: '/taxDateTimeSelection',
        query: {
            memberId,
            serviceId: govDetailList[index].appointGovItemId
        }
    })
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      class: "pull-refresh",
      "success-text": "刷新成功",
      modelValue: loading.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_van_icon, {
                name: "search",
                size: "22",
                color: "#999"
              }),
              _createVNode(_component_van_field, {
                class: "search-value",
                modelValue: searchValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
                label: "",
                placeholder: "请输入搜索关键字"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_van_button, {
              class: "search-btn",
              onClick: clickSearchBtn
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (serviceList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_van_list, {
                      loading: listLoading.value,
                      "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((listLoading).value = $event)),
                      finished: finished.value,
                      "finished-text": "没有更多了"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceList.value, (item, index) => {
                          return (_openBlock(), _createBlock(_component_van_cell, {
                            size: "large",
                            key: item,
                            title: item,
                            clickable: "",
                            onClick: ($event: any) => (clickSelectedService(index)),
                            "is-link": ""
                          }, null, 8, ["title", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["loading", "finished"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})